import { useAppSelector } from "app/store";

export const useUserNameSelector = () => {
  const userName = useAppSelector((state) => state.auth.user.alias);
  return { userName };
};

export const useTeamNameSelector = () => {
  const teamName = useAppSelector((state) => state.audits.teamName);
  return { teamName };
};

export const useHeaderTeamNameSelector = () => {
  return useAppSelector((state) => state.audits.headerSelectedTeam);
};

export const useTeamName = () => {
  const currentResourceTeam = useAppSelector((state) => state.audits.teamName);
  const headerSelectedTeam = useAppSelector(
    (state) => state.audits.headerSelectedTeam,
  );

  return { currentResourceTeam, headerSelectedTeam };
};

export { useAppSelector };
